import styled from 'styled-components';

export const ChartActionWrapper = styled('div')`
  text-align: right;
  margin-top: ${({ theme }) => theme.x3spacePx}px;
`;
